import { Component, h, Prop } from '@stencil/core';
import { ButtonSimpleStyles } from '../../../types/types';

@Component({
    tag: 'rentware-button-simple',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareButton {
    @Prop() buttonText: string;
    @Prop() onClick: () => void = () => { };
    @Prop() disabled: boolean;
    @Prop() isWaiting: boolean;
    @Prop() buttonStyle: ButtonSimpleStyles = ButtonSimpleStyles.Default;

    get tabIndex() {
        if (this.isWaiting) {
            return -1;
        } else {
            return 0;
        }
    }

    get buttonInactive() {
        return this.isWaiting || this.disabled;
    }

    get buttonClass() {
        const status = this.buttonInactive ? "" : this.buttonStyle + "ButtonSimpleActive";

        return "RentwareButtonSimple " + this.buttonStyle + "ButtonSimple " + status;
    }

    get callback() {
        if (this.isWaiting || this.disabled) {
            return () => { }
        } else {
            return this.onClick;
        }
    }

    render() {
        return (
            <div
                class={this.buttonClass}
                tabIndex={this.tabIndex}
                onClick={this.callback}
            >
                <span class="ButtonText">
                    {this.buttonText}
                </span>

                {this.buttonInactive && <div class={{ InactiveContainer: true, WaitingContainer: this.isWaiting }} />}
            </div>
        )
    }
}
